<template>
	    <!-- 更改房态弹窗 -->
	<div v-if="data.isShow">
	    <div class="mask update-room">
	        <div class="e-modal small">
	            <div class="e-modal-title">更改房态 <i class="e-modal-close" @click="close"></i></div>
              <div class="e-modal-date" style="max-height: 95px;overflow-y: scroll;height: auto;">
                <div class="room-name" v-if="scope==='scope2'">{{rps.RoomName||rooms.Name}}</div>
									<div class="room-name" style="line-height: normal;padding: 10px 0;" v-else-if="scope==='scope3'">
										<div v-for="R in rooms.RPS">
											{{R.RatePlanName}}
										</div>
									</div>
									<div class="room-name" v-else>{{rps.RatePlanName||rooms.Name}}</div>
              </div>

              <div>
                <div class="section-main" style="position: absolute;">
                    <div class="filter">
                      <div class="choose-date">
                        <div class="bimestrial" style="top:20px;width: 440px;">
                          <datePicker v-if="datePickerData.show" :beginSlot='datePickerData.beginSlot' :endSlot='datePickerData.endSlot' @onDateChange="datePickerData.DateChange" ></datePicker>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
	          
							
	            <div class="e-modal-body">
                  <div class="body-item">
                    <span>日期：</span>
                    <label class="room-time" @click="datePickerData.show=true">
                      <label style="padding: 0 15px;">{{datePickerData.beginSlot|dateToLineDvd}} {{datePickerData.beginSlot|dateWeek}}</label>
                        - 
                      <label style="padding: 0 15px;">{{datePickerData.endSlot|dateToLineDvd}} {{datePickerData.endSlot|dateWeek}}</label>
                    </label>
                  </div>
									<div class="body-item">
	                	<span>修改范围：</span>
										<label @mouseenter="layer2=true" @mouseleave="layer2=false"><input type="radio" id="scope2" v-model="scope" :disabled="rooms.RPS.length<2" value="scope2">房型(共享库存) <img src="../../../../assets/images/AK.png" mode="scaleToFill"></label>
	                	<p style="padding: 10px 74px;cursor: default;"><span @mouseenter="layer1=true" @mouseleave="layer1=false"><input :disabled="data.hidden" type="radio" id="scope1" v-model="scope" value="scope1">价格计划(独立库存) <img src="../../../../assets/images/AK.png" mode="scaleToFill"></span></p>
	                	
										<p style="padding: 0  0 10px 74px;cursor: default;"><span @mouseenter="layer3=true" @mouseleave="layer3=false"><input :disabled="data.hidden||rooms.RPS.length<2" type="radio" id="scope3" v-model="scope" value="scope3">所有价格计划(独立库存) <img src="../../../../assets/images/AK.png" mode="scaleToFill"></span></p>
										<div class="layer" v-if="layer1">修改当前价格计划房态{{!hideRoomCount?'/房量':''}}</div>
										<div class="layer layer2" v-if="layer2">修改当前价格计划所在房型的共享房态{{!hideRoomCount?'/房量':''}}</div>
										<div class="layer layer3" v-if="layer3">修改所有价格计划房态{{!hideRoomCount?'/房量':''}}</div>
										
	                </div>
	                <div class="body-item" v-if="!hideRoomStatus">
	                	<span class="label">房态： </span>
	                	<label for="roomState1"><input :disabled="data.hidden" type="radio" id="roomState1" v-model="data.S" value="026001">开</label>
	                	<label for="roomState2"><input :disabled="data.hidden" type="radio" id="roomState2" v-model="data.S" value="026002">关</label>
										<input type="checkbox" :disabled="data.hidden" v-model="hideRoomCount" style="margin-left: 15px;"> 只修改房态
	                </div>
	                <div class="body-item" v-if="!hideRoomCount">
	                	<span class="label">房量： </span>
	                	<label for=""><input type="radio" name="roomCount" v-model="data.A" :value="true" :disabled="scope=='scope2'"/>R </label>
	                	<label for="">
	                		<input type="radio" name="roomCount" v-model="data.A" :value='false'/>
	                		<input type="text" v-model="currentValue" maxlength="2" v-if="!data.A||data.A=='false'"/>
	                		<input type="text" v-if="data.A=='true'||data.A==true" disabled/>
                      <input type="checkbox" :disabled="data.hidden" v-model="hideRoomStatus" style="margin-left: 10px;"> 只修改房量
	                	</label>
                    <div style="color:red;padding: 5px;padding-left: 110px;">{{!data.A?numText:""}}</div>
										<div>
											<span class="label"></span>
											<label for="checkbox32">
												<input type="checkbox" id='checkbox32' v-model="data.O" v-if="(!data.A||data.A=='false')&&!data.hidden">
                        <input type="checkbox" v-else disabled/>
												<!-- <input type="checkbox" v-else-if="(data.A=='true'||data.A==true)&&!data.hidden" disabled />
                        <input type="checkbox" v-else-if="(data.A=='true'||data.A==true)&&data.hidden" :disabled="data.hidden" /> -->
												可超售
											</label>
										</div>
	                </div>
	                
									
	            </div>
	            <div class="e-modal-footer">
	                <div class="long-btn save-btn" v-if="data.hidden&&datePickerData.dateArr.length==1" @click="setShare">保存</div>
                  <div class="long-btn save-btn" v-else-if="datePickerData.dateArr.length>1" @click="batchSave">保存</div>
									<div class="long-btn save-btn" v-else @click="save">保存</div>
	                <div class="long-btn cancel-btn" @click="data.isShow=false">取消</div>
	            </div>
	        </div>
	    </div>
    </div>
	
</template>
<script>
import datePicker from "./../../../../common/DatePicker/DatePicker1.vue";
export default {
  name: "roomStatusSingle",
  components: {
    datePicker
  },
  props: {
    cmData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    rps: {
      type: Object,
      default: function() {
        return {};
      }
    },
    rooms: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  
  data() {
    return {
      data: {},
      hideRoomCount: false,
      hideRoomStatus:false,
      scope: "scope1",
      // scopeFlag:true,
      layer1: false,
      layer2: false,
      layer3: false,
      // oldIsShared:'',
      datePickerData: {
        beginSlot: "",
        endSlot: "",
        dateArr: [],
        show: false,
        DateChange: (arr, begin, end) => {
          if (!begin) {
            this.datePickerData.show = false;
            return;
          }
          this.datePickerData.dateArr = arr;
          this.datePickerData.beginSlot = begin;
          this.datePickerData.endSlot = end;
          this.datePickerData.show = false;
        }
      },
      numText:'',
    };
  },
  computed: {
    currentValue: {
      get() {
        return this.data.SC || this.data.SSC;
      },
      set(val) {
        // 处理非法字符
        this.data.SC = val;
        this.data.SSC = val;
        val = String(val).replace(/\D/g, '');
        val  = Number(val)
        this.data.SC = val;
        this.data.SSC = val;
      }
    }
  },
  watch: {
    cmData(val) {
      this.data = val;
      this.datePickerData.beginSlot = val.PD.replace(/\//g, "-");
      this.datePickerData.endSlot = val.PD.replace(/\//g, "-");
      this.datePickerData.dateArr = [(val.PD.replace(/\//g, "-"))]
      // this.oldIsShared = val.IsShared
      // 不是仅共享渠道
      if (!this.data.hidden) {
        if (this.data.S != "026001") {
          this.data.S = "026002";
        }
        if (this.data.A != true) {
          this.data.A = false;
        }
        if (!this.data.SC) {
          this.data.SC = 0;
        }
        if (!this.data.SSC) {
          this.data.SSC = 0;
        }
        if (!this.data.O) {
          this.data.O = false;
        }
        if (this.data.IsShared) {
          this.scope = "scope2";
          this.data.A = false
        } else {
          this.scope = "scope1";
        }
      } else {
        this.scope = "scope2";
        this.data.A = false
        this.hideRoomStatus = true
        if (!this.data.SC) {
          this.data.SC = 0;
        }
        if (!this.data.SSC) {
          this.data.SSC = 0;
        }
      }
      if(this.rooms.RPS.length<2){
        this.scope = "scope1";
      }
    },
    currentValue(Val) {
      var that = this
      if (Val < 1) {
          that.numText = '房量必须大于  0'
      }else{
          that.numText = ''
      }
      if (Val > 99) {
          that.numText = '房量最大为  99'
      }
    },
    'data.A'(Val) {
      var that = this
      if(!Val){
        if (that.currentValue < 1) {
            that.numText = '房量必须大于  0'
        }
        if (that.currentValue > 99) {
            that.numText = '房量最大为  99'
        }
      }else{
        that.numText = ''
      }
    },
    scope(Val){
				if(Val=='scope2'){
					this.data.A = false
				}
		}
  },
  methods: {
    close(){
      this.data.isShow = false;
      this.datePickerData.show = false;
      this.hideRoomStatus= false
      this.hideRoomCount = false
    },
    getAllRps() {
      var that = this;
      var list = [];
      var room = that.rooms;
      room.RPS.forEach(function(item) {
        var obj = {
          HotelID: item.HotelId,
          RoomID: item.RoomId,
          RPID: item.RatePlanId,
          RateID: item.RateId,
          IsShared: that.scope == "scope2" ? true : false
        };
        list.push(obj);
      });
      return list;
    },
    batchSave() {
      var that = this;
      var rps = that.rps;
			var data = that.data;
      var count = data.SC||data.SSC
      if (!that.hideRoomCount) {
        if (!data.A) {
          if (count < 1) return;
        }
        if (count > 99) return;
      }
      var rpData = [];
      if (that.scope == "scope1") {
        rpData = [
          {
            HotelID: rps.HotelId,
            RoomID: rps.RoomId,
            RPID: rps.RatePlanId,
            RateID: rps.RateId,
            IsShared: that.scope == "scope2" ? true : false
          }
        ];
      } else {
        rpData = that.getAllRps();
      }
      var params = {
        DateRange: {
          Dates: this.datePickerData.dateArr,
          Excepts: null,
          Type: 0,
          WeekDays: null
        },
        RPs: rpData,
        StartDate: that.datePickerData.beginSlot,
        EndDate: that.datePickerData.endSlot,
        IsOpen: data.S == "026001" ? true : false,
        IsAsk: data.A,
        Count: count,
        AllowOver: data.A?false:data.O,
        IsOnlyChangeRoomStatus: that.hideRoomCount,
        IsOnlyChangeStockNum: that.hideRoomStatus
      };
      that
        .patchRequest({
          url: that.Api.batchState,
          params: JSON.stringify(params)
        })
        .then(res => {
          if (res && res.IsSuccess) {
            if(data.hidden){
              this.$emit("saveShare");
            }else{
              this.$emit("upData");
            }
            
            this.data.isShow = false;
            // this.error({ title: '提示', content: '保存成功' });
          } else {
            that.error({ title: "提示", content: res.Msg||"提交失败，请重新提交" });
          }
        });
    },
    save() {
      var that = this;
      var data = that.data;
      var rps = that.rps;
      var rooms = that.rooms;
      var count = data.SC||data.SSC
      if (!that.hideRoomCount) {
        if (!data.A) {
          if (count < 1) return;
        }
        if (count > 99) return;
      }
      

      var RPInfos = "";
      if (this.scope == "scope1") {
        RPInfos = [
          {
            RPId: rps.RatePlanId,
            RateId: rps.RateId
          }
        ];
      } else {
        var arr = [];
        if (rooms && rooms.RPS.length > 0) {
          rooms.RPS.forEach(element => {
            var obj = {};
            obj.RPId = element.RatePlanId;
            obj.RateId = element.RateId;
            arr.push(obj);
          });
        }
        RPInfos = arr;
      }
      var params = {
        HotelId: rps.HotelId,
        RoomId: rps.RoomId,
        RPInfos: RPInfos,
        Date: data.PD,
        IsOpen: data.S == "026001" ? true : false,
        IsAsk: data.A,
        Count: count,
        AllowOver: data.A?false:data.O,
        IsShared: this.scope == "scope2" ? true : false,
        IsOnlyChangeRoomStatus: that.hideRoomCount,
        IsOnlyChangeStockNum: that.hideRoomStatus
      };
      that
        .patchRequest({
          url: that.Api.updateStateSingle,
          params: params
        })
        .then(res => {
          if (res && res.IsSuccess) {
            this.$emit("upData");
            this.data.isShow = false;
            // this.error({ title: '提示', content: '保存成功' });
          } else {
            that.error({ title: "提示", content: res.Msg||'提交失败，请重新提交' });
          }
        });
    },
    setShare() {
      var that = this;
      var count = that.data.SC||that.data.SSC
      if (!that.hideRoomCount) {
        if (!that.data.A) {
          if (count < 1) return;
        }
        if (count > 99) return;
      }
      var params = {
        HotelId: that.rooms.RPS[0].HotelId,
        RoomId: that.rooms.RPS[0].RoomId,
        Date: that.data.PD,
        Count: count,
        IsShared: this.scope == "scope2" ? true : false,
      };
      that
        .patchRequest({
          url: that.Api.setShare,
          params: params
        })
        .then(res => {
          if (res && res.IsSuccess) {
            that.$emit("saveShare");
          } else {
            that.error({ title: "提示", content: res.Msg||'提交失败，请重新提交' });
          }
        });
    }
  },
  mounted() {
    this.data = this.cmData;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/roomStatus/datePriceTable/roomStatusEdit/RoomStatusSingle.vue